module.exports = __webpack_public_path__ + "img/1F4E9.8096da46.svg";